import { adminFetch } from "./_client";
import type { FlowStudioBrandKit, FlowStudioAsset, FlowStudioRichTemplate, ShortRefMigrationResponse } from "./types";

export function migrateStudioTemplatesShortRef(token: string, apply: boolean) {
  return adminFetch<ShortRefMigrationResponse>("/admin/flow-studio/templates/migrate-short-ref", token, {
    method: "POST", body: JSON.stringify({ apply }),
  });
}


export function fetchStudioBrandKit(token: string) {
  return adminFetch<{ brandKit: FlowStudioBrandKit }>("/admin/flow-studio/brand-kit", token);
}

export function updateStudioBrandKit(token: string, patch: Partial<FlowStudioBrandKit>) {
  return adminFetch<{ brandKit: FlowStudioBrandKit }>("/admin/flow-studio/brand-kit", token, {
    method: "PUT", body: JSON.stringify(patch),
  });
}

export function fetchStudioAssets(token: string) {
  return adminFetch<{ assets: FlowStudioAsset[] }>("/admin/flow-studio/assets", token);
}

export function createStudioAsset(token: string, body: { name: string; url: string; mime?: string; width?: number; height?: number; bytes?: number }) {
  return adminFetch<{ asset: FlowStudioAsset }>("/admin/flow-studio/assets", token, {
    method: "POST", body: JSON.stringify(body),
  });
}

export function requestStudioAssetUploadUrl(token: string, body: { filename: string; contentType?: string; size?: number }) {
  return adminFetch<{ uploadUrl: string; publicUrl: string; objectKey: string }>("/admin/flow-studio/assets/upload-url", token, {
    method: "POST", body: JSON.stringify(body),
  });
}

export function deleteStudioAsset(token: string, id: number) {
  return adminFetch<{ ok: boolean }>(`/admin/flow-studio/assets/${id}`, token, { method: "DELETE" });
}

export function fetchStudioTemplates(token: string, channel?: "email" | "sms" | "push") {
  const qs = channel ? `?channel=${channel}` : "";
  return adminFetch<{ templates: FlowStudioRichTemplate[] }>(`/admin/flow-studio/templates${qs}`, token);
}

export function fetchStudioTemplate(token: string, id: string) {
  return adminFetch<{ template: FlowStudioRichTemplate }>(`/admin/flow-studio/templates/${encodeURIComponent(id)}`, token);
}

export function saveStudioTemplate(token: string, body: { id?: string; channel: "email" | "sms" | "push"; name: string; description?: string; category?: string; is_starter?: boolean; thumbnail_url?: string; payload: Record<string, unknown> }) {
  return adminFetch<{ template: FlowStudioRichTemplate }>("/admin/flow-studio/templates", token, {
    method: "POST", body: JSON.stringify(body),
  });
}

export function patchStudioTemplate(token: string, id: string, patch: { name?: string; description?: string; category?: string; thumbnail_url?: string; payload?: Record<string, unknown> }) {
  return adminFetch<{ template: FlowStudioRichTemplate }>(`/admin/flow-studio/templates/${encodeURIComponent(id)}`, token, {
    method: "PATCH", body: JSON.stringify(patch),
  });
}

export function deleteStudioTemplate(token: string, id: string) {
  return adminFetch<{ ok: boolean }>(`/admin/flow-studio/templates/${encodeURIComponent(id)}`, token, { method: "DELETE" });
}

export function duplicateStudioTemplate(token: string, id: string) {
  return adminFetch<{ template: FlowStudioRichTemplate }>(`/admin/flow-studio/templates/${encodeURIComponent(id)}/duplicate`, token, { method: "POST" });
}

export function importStudioTemplate(token: string, body: { name: string; channel?: "email" | "sms" | "push"; source?: "html" | "txt" | "eml"; content?: string; subject?: string; body?: string }) {
  return adminFetch<{ template: FlowStudioRichTemplate }>("/admin/flow-studio/templates/import", token, {
    method: "POST", body: JSON.stringify(body),
  });
}

export function sendStudioTestEmail(token: string, body: { to: string; subject: string; html: string }) {
  return adminFetch<{ ok: boolean; sent: boolean }>("/admin/flow-studio/send-test", token, {
    method: "POST", body: JSON.stringify(body),
  });
}
